import { Component, inject, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TagCommanderService } from 'ngx-tag-commander'; // EasyTrack: KPI 1 & 13
import { environment } from '@environments/environment'; // EasyTrack: KPI 1 & 13

@Component({
  selector: 'tmn-header-bar-button',
  standalone: true,
  templateUrl: './header-button.component.html',
  styleUrl: './header-button.component.scss',
  imports: [RouterLink, RouterLinkActive, MatIconModule],
})
export class HeaderBarButtonComponent {
  @Input() teamsCampaignVisible!: boolean;
  @Input() thresholdsVisible!: boolean;

  private readonly tcService = inject(TagCommanderService); // EasyTrack: KPI 1 & 13

  trackMenuClick(event: MouseEvent, label: string, section: string): void { // EasyTrack: KPI 1 & 13
    const payload = { event_name: 'menu_item_clicked', is_button: false, label, section_name: section };
    if (!environment.production) { console.log('[EasyTrack] menu_item_clicked', payload); }
    this.tcService.triggerEvent('menu_item_clicked', event.currentTarget as HTMLElement, payload);
  }
}
